import { JSX } from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import FeedbackButton from "lib/components/button/FeedbackButton";
import { asTitle } from "utils/Utils";

export type ConfirmationDialogProps = {
	title: string;
	dialogText: string;
	cancelLabel: string;
	confirmLabel: string;

	onClose: () => void;
	onConfirm: () => Promise<void>;
};

export default function ConfirmationDialog(
	props: Readonly<ConfirmationDialogProps>
): JSX.Element {
	return (
		<Dialog
			open={true}
			fullWidth={true}
			maxWidth={"sm"}
			onClose={props.onClose}>
			<DialogTitle>{asTitle(props.title)}</DialogTitle>
			<DialogContent>
				{props.dialogText.split("<br />").map(text => (
					<DialogContentText key={text}>{text}</DialogContentText>
				))}
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={props.onClose}>
					{props.cancelLabel}
				</Button>
				<FeedbackButton
					variant="contained"
					label={props.confirmLabel}
					onClick={props.onConfirm}
				/>
			</DialogActions>
		</Dialog>
	);
}
